import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"static/js/components-wa/containers/Media.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72a4e9a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72a4e9a8', __exports__)) {
    api.reload('72a4e9a8', __exports__)
  }
  
}


export default __exports__